import { useState, useEffect } from 'react'
import api, { IAssignmentPlan } from '@api'

export default function useImportMovePlan() {
  const [plan, setPlan] = useState<IAssignmentPlan | null>(null)

  useEffect(() => {
    api.ap.list().then((groups) => {
      let importPlan: IAssignmentPlan | undefined

      groups.forEach(({ assignmentPlans }) => {
        if (!importPlan) {
          importPlan = assignmentPlans.find(({ name }) => name === 'Import')
        }
      })

      importPlan && setPlan(importPlan)
    })
  }, [])

  return { plan }
}
